import { render, staticRenderFns } from "./txManager.vue?vue&type=template&id=751dc099&scoped=true&"
import script from "./txManager.vue?vue&type=script&lang=js&"
export * from "./txManager.vue?vue&type=script&lang=js&"
import style0 from "./txManager.vue?vue&type=style&index=0&id=751dc099&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751dc099",
  null
  
)

export default component.exports